module.exports = __webpack_public_path__ + "static/media/o15.4092706c.png";